<form class="pt-4" [formGroup]="form">
  <ng-container>
    <div class="p-float-label mb-5">
      <input class="w-full" pInputText [formControl]="paramsForm.controls.brokers" />
      <label>{{ 'data-source.kafka.label.brokers' | translate }}</label>
    </div>
    <div class="p-float-label mb-5">
      <input class="w-full" pInputText [formControl]="paramsForm.controls.topic" />
      <label>{{ 'data-source.kafka.label.topic' | translate }}</label>
    </div>
    <div class="mb-5">
      <label class="cursor-pointer">
        <p-checkbox class="mr-2" [formControl]="paramsForm.controls.sslEnabled" [binary]="true"></p-checkbox>
        {{ 'data-source.common.checkbox.ssl-enabled' | translate }}
      </label>
    </div>

    <ng-container *ngIf="this.paramsForm.controls.sslEnabled.value">
      <div class="p-float-label mb-5">
        <p-password
          styleClass="w-full"
          inputStyleClass="w-full"
          [formControl]="paramsForm.controls.sslKeystoreLocation"
          [toggleMask]="true"
          [feedback]="false"
        ></p-password>
        <label>{{ 'data-source.kafka.label.ssl-keystore-location' | translate }}</label>
      </div>
      <div class="p-float-label mb-5">
        <p-password
          styleClass="w-full"
          inputStyleClass="w-full"
          [formControl]="paramsForm.controls.sslKeystorePassword"
          [toggleMask]="true"
          [feedback]="false"
        ></p-password>
        <label>{{ 'data-source.kafka.label.ssl-keystore-password' | translate }}</label>
      </div>
      <div class="p-float-label mb-5">
        <p-password
          styleClass="w-full"
          inputStyleClass="w-full"
          [formControl]="paramsForm.controls.sslTruststoreLocation"
          [toggleMask]="true"
          [feedback]="false"
        ></p-password>
        <label>{{ 'data-source.kafka.label.ssl-truststore-location' | translate }}</label>
      </div>
      <div class="p-float-label mb-5">
        <p-password
          styleClass="w-full"
          inputStyleClass="w-full"
          [formControl]="paramsForm.controls.sslTruststorePassword"
          [toggleMask]="true"
          [feedback]="false"
        ></p-password>
        <label>{{ 'data-source.kafka.label.ssl-truststore-password' | translate }}</label>
      </div>
    </ng-container>
  </ng-container>

  <div class="mb-5">
    <selfai-platform-data-source-visibility
      [control]="form.controls.visibility"
    ></selfai-platform-data-source-visibility>
  </div>

  <div class="mb-5">
    <selfai-platform-data-source-unique-name [control]="form.controls.name"></selfai-platform-data-source-unique-name>
  </div>

  <selfai-platform-data-sources-additionals
    [properties]="dataSource?.params?.properties"
    [additionalList]="additionalList"
    (changeEvent)="onPropertiesValue($event)"
  ></selfai-platform-data-sources-additionals>
</form>
